<!-- <button mat-mini-fab color="primary" (click)="addRow()" *ngIf="editMode">
<mat-icon>add</mat-icon>
</button> -->

<mat-form-field class="example-full-width">
  <mat-select [(ngModel)]="offerId" [disabled]="!editMode">
    @for (offer of offers; track offer) {
      <mat-option [value]="offer.id" (onSelectionChange)="onOfferChange(offer, $event, undefined)">
        {{ offer.name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>

@if (selected) {
  <app-nested-panel-form-field
    [fields]="fields"
    [canAdd]="false"
    [editMode]="editMode"
    [fieldConfig]="selectedFieldConfig"
    [formGroup]="formGroup"
    [(data)]="offerData"></app-nested-panel-form-field>
}
